import React, { useEffect, useState } from "react";

// Champ horaire 24h — affichage et saisie strictement au format HH:mm (aucun AM/PM).
export function normalizeTime(raw) {
  let s = (raw || "").trim();
  if (!s) return "";
  s = s.replace(/[hH.,\s]/g, ":");
  let hh, mm;
  if (s.includes(":")) {
    const parts = s.split(":");
    hh = parts[0];
    mm = parts[1] || "0";
  } else if (s.length <= 2) {
    hh = s;
    mm = "0";
  } else {
    hh = s.slice(0, -2);
    mm = s.slice(-2);
  }
  let H = parseInt(hh, 10);
  let M = parseInt(mm, 10);
  if (isNaN(H)) return "";
  if (isNaN(M)) M = 0;
  H = Math.min(23, Math.max(0, H));
  M = Math.min(59, Math.max(0, M));
  return `${String(H).padStart(2, "0")}:${String(M).padStart(2, "0")}`;
}

export function TimeInput({ value, onChange, testid, className, placeholder = "HH:mm" }) {
  const [text, setText] = useState(value || "");
  useEffect(() => { setText(value || ""); }, [value]);

  const commit = () => {
    const n = normalizeTime(text);
    setText(n);
    if (n !== (value || "")) onChange(n);
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      maxLength={5}
      placeholder={placeholder}
      data-testid={testid}
      className={className}
      value={text}
      onChange={(e) => setText(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); commit(); } }}
    />
  );
}
